import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./css/cookiebot.css";
import './js/cookiebot';

// Kunsthaus
import Home from "./views/Home";
//import CalendarAbramovic from "./views/Step10_Abramovic_Calendar";
//import ToursAbramovic from "./views/Step15_Tours_Abramovic";
//import TicketsAbramovic from "./views/Step15_Tickets_Abramovic";
//import TicketsSigner from "./views/Step10_Tickets_Signer";
//import TicketsChetwynd from "./views/Step10_Tickets_Chetwynd";
//import TicketsWilhelmLehmbruck from "./views/Step10_Tickets_WilhelmLehmbruck";
//import TicketsSummerCampaignSummerFriends from "./views/Step10_Tickets_SummerCampaign_SummerFriends";
//import TicketsSummerCampaignCoolDown from "./views/Step10_Tickets_SummerCampaign_CoolDown";
//import CalendarAllInclusive from "./views/Step10_AllInclusive_Calendar";
//import PreviewAbramovic from "./views/Step15_Preview_Abramovic";
//import TicketsBringAFriend from "./views/Step10_Tickets_BringAFriend";
//import CurrentTimeSlotsOverview from "./views/CurrentTimeSlotsOverview";
/*import TicketsLygiaClarkValentine from "./views/Step10_Tickets_LygiaClarkValentine";*/

import TicketsCollection from "./views/Step10_Tickets_Collection";

import TicketsLygiaClark from "./views/Step10_Tickets_LygiaClark";
import TicketsKerryJamesMarshall from "./views/Step10_Tickets_KerryJamesMarshall";
import TicketsMarisol from "./views/Step10_Tickets_Marisol";
import TicketsAllInclusive from "./views/Step10_Tickets_AllInclusive";
import Shipping from "./views/Step20_Shipping";
import Checkout from "./views/Step30_Checkout";
import Confirmation from "./views/Step40_Confirmation";

import ScrollToTop from './views/components/ScrollToTop';

// Fallback page
import PageNotFound from "./views/components/PageNotFound";

function App() {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <ScrollToTop />
                <LanguageRouter />
            </BrowserRouter>
        </HelmetProvider>
    );
}


// LanguageRouter component to handle lang attribute dynamically
function LanguageRouter() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Detect browser language
        const browserLanguage = navigator.language || navigator.userLanguage;
        const langCode = browserLanguage.split("-")[0]; // Get language code (e.g., 'en' from 'en-US')

        const supportedLanguages = ["de", "en", "fr"];
        const defaultLang = "de";

        const selectedLang = supportedLanguages.includes(langCode) ? langCode : defaultLang;

        // Set the lang attribute dynamically for SEO and accessibility
        document.documentElement.lang = selectedLang;
    }, [location, navigate]);

    return (
        <Routes>
            <Route path="*" element={<PageNotFound />} />
            <Route path="/" element={<LanguageRedirect />} />
            {/* Redirect from "/:language/" to "/:language/home" */}
            <Route path="/:language" element={<Navigate to="home" replace />} />
            <Route path="/:language/home" element={<Home />} />
            {/*<Route path="/:language/marina-abramovic" element={<CalendarAbramovic />} />*/}
            {/*<Route path="/:language/marina-abramovic-tours" element={<ToursAbramovic />} />*/}
            {/*<Route path="/:language/marina-abramovic-tickets/:eventId" element={<TicketsAbramovic />} />*/}
            {/*<Route path="/:language/marina-abramovic-preview" element={<PreviewAbramovic />} />*/}
            {/*<Route path="/:language/signer" element={<TicketsSigner />} />*/}
            {/*<Route path="/:language/chetwynd" element={<TicketsChetwynd />} />*/}
            {/*<Route path="/:language/wilhelm-lehmbruck" element={<TicketsWilhelmLehmbruck />} />*/}
            {/*<Route path="/:language/summerfriends" element={<TicketsSummerCampaignSummerFriends />} />*/}
            {/*<Route path="/:language/cool-down" element={<TicketsSummerCampaignCoolDown />} />*/}
            {/*<Route path="/:language/all-inclusive" element={<CalendarAllInclusive />} />*/}
            {/*<Route path="/:language/all-inclusive-tickets/:eventId" element={<TicketsAllInclusive />} />*/}
            {/*<Route path="/:language/bring-a-friend" element={<TicketsBringAFriend />} />*/}
            {/*<Route path="/:language/valentines-lygia-clark" element={<TicketsLygiaClarkValentine />} />*/}
            
            <Route path="/:language/sammlung" element={<TicketsCollection />} />
            <Route path="/:language/lygia-clark" element={<TicketsLygiaClark />} />
            <Route path="/:language/kerry-james-marshall" element={<TicketsKerryJamesMarshall />} />
            <Route path="/:language/marisol" element={<TicketsMarisol />} />
            <Route path="/:language/all-inclusive-tickets" element={<TicketsAllInclusive />} />
            <Route path="/:language/shipping" element={<Shipping />} />
            <Route path="/:language/checkout" element={<Checkout />} />
            <Route path="/:language/confirmation" element={<Confirmation />} />
            <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />

            {/*<Route path="/:language/timeslots-overview" element={<CurrentTimeSlotsOverview />} />*/}
        </Routes>
    );
}

// Component for auto-redirecting to the detected language
const LanguageRedirect = () => {
    const browserLanguage = navigator.language.split("-")[0];
    const supportedLanguages = ["de", "en", "fr"];
    const defaultLang = "de";

    const selectedLang = supportedLanguages.includes(browserLanguage) ? browserLanguage : defaultLang;

    return <Navigate to={`/${selectedLang}/home`} replace />;
};

export default App;